// DeleteModal.tsx

import React, { Dispatch, SetStateAction } from "react";
import PathFinderButton from "../PathFinderButton";

interface DeleteModalProps {
  showModal: boolean;
  handleConfirmDelete: () => void;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  text: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  showModal,
  handleConfirmDelete,
  setShowModal,
  loading,
  text,
}) => {
  return (
    <>
      {showModal && (
        <div className="fixed top-[-4rem] left-0 right-0 bottom-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-xl mx-4">
            <p className="text-xl mb-4 max-w-[30rem] text-center">{text}</p>
            <div className="flex justify-center mt-[2rem] pt-§ space-x-4 items-center">
              <PathFinderButton
                type="button"
                onClick={handleConfirmDelete}
                loading={loading}
                disabled={false}
                outlined={true}
              >
                Yes
              </PathFinderButton>
              <PathFinderButton
                onClick={() => setShowModal(false)}
                loading={false}
                type="button"
                disabled={false}
              >
                Go Back
              </PathFinderButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteModal;
